import { PaletteMode } from '@mui/material';
import { orange } from '@mui/material/colors';

export const light = {
  mode: 'light' as PaletteMode,
  primary: {
    main: '#2641a2', // Updated to your custom blue
    contrastText: 'rgb(100, 101, 98)', // You can keep this for contrast text if needed
  },
  success: {
    main: '#2641a2', // Changed green to #2641a2 for success color
    light: '#4c72e3', // Lighter shade of your primary color
    dark: '#002b72', // Darker shade of your primary color
  },
  text: {
    primary: 'rgb(40, 40, 40)',
    secondary: 'rgb(103, 119, 136)',
  },
  background: {
    paper: 'rgb(242, 243, 245)',
    default: 'rgb(255, 255, 255)',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
};

export const dark = {
  mode: 'dark' as PaletteMode,
  primary: {
    main: '#2641a2', // Same primary color in dark mode
    contrastText: 'rgb(100, 101, 98)',
  },
  warning: {
    main: 'rgb(242, 175, 87)',
    light: 'rgb(245, 205, 130)',
    dark: orange[600],
  },
  text: {
    primary: 'rgb(255, 255, 255)',
    secondary: 'rgb(207, 207, 207)',
  },
  background: {
    default: 'rgb(0, 0, 0)',
    paper: 'rgb(15, 15, 15)',
  },
  divider: 'rgba(145, 158, 171, 0.24)',
};
